const CAPTURE_DATE_FIELDS = [
  "capture_date_time",
  "captured_at",
  "captured_date_time",
  "capture_datetime",
  "created_at",
];

export const getDataCaptureDate = (item = {}) => {
  const field = CAPTURE_DATE_FIELDS.find((key) => {
    const value = item[key];
    return value !== undefined && value !== null && String(value).trim() !== "";
  });

  return field ? item[field] : null;
};

